<div class="modal-backdrop" *ngIf="visible">
  <div class="custom-modal">
    <div class="modal-header">
      <h5 class="modal-title">Selecciona el cliente</h5>
    </div>

    <div class="modal-body">
      <select class="form-select custom-select" [(ngModel)]="selectedClientId">
        <option [ngValue]="null">Todos los clientes</option>
        <option *ngFor="let c of clientes" [ngValue]="c.id">
          {{ c.name }}
        </option>
      </select>
    </div>

    <div class="modal-footer">
      <button class="btn btn-secondary" (click)="cancelar()">Cancelar</button>
      <button class="btn btn-primary" (click)="aceptar()">Aceptar</button>
    </div>
  </div>
</div>
